import { render } from "./PLEHeader.vue?vue&type=template&id=5bf802ca&scoped=true"
import script from "./PLEHeader.vue?vue&type=script&lang=js"
export * from "./PLEHeader.vue?vue&type=script&lang=js"

import "./PLEHeader.vue?vue&type=style&index=0&id=5bf802ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf802ca"]])

export default __exports__